import React, { useEffect, useState } from "react";
import { FaMagnifyingGlass } from "react-icons/fa6";

function BuckList({ bucksObject, isMobile, style, onDoubleClick }) {
    const [selectedBox, setSelectedBox] = useState(null);
    const [bucks, setBucks] = useState(null);
    const [search, setSearch] = useState(null);
    
    const mapNewBucksObject = async () => {
        let newBucksObject = {};
        await Promise.all(Object.values(bucksObject).map((buck) => {
            if(buck.name.toLowerCase().includes(search) || buck.age.toString().includes(search) || buck.points.toString().includes(search) || buck.classification.toLowerCase().includes(search)) {
                Object.assign(newBucksObject, { [buck.name]: buck });
            }
            return true;
        }));

        return newBucksObject;
    };

    useEffect(() => {
        if(bucksObject) {
            if(search) {
                mapNewBucksObject().then((newBucksObject) => {
                    setBucks(newBucksObject);
                });
            } else {
                setBucks(bucksObject);
            }
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [bucksObject, search]);

    return (
        <div style={{ ...style }}>
            <div style={{ "display": "flex", "alignItems": "center", "border": "1px solid #ccc", "borderRadius": "8px", "padding": "2px", "backgroundColor": "#fff" }}>
                <FaMagnifyingGlass style={{ "marginRight": "8px", "marginLeft": "8px", "color": "#888", "fontSize": "16px" }} />
                <input style={{ "border": "none", "outline": "none", "padding": "5px", "width": "200px" }} onChange={(e) => { e.preventDefault(); setSearch(e.target.value); }} type="text" placeholder="Buck Search" />
            </div>
            {bucks && Object.keys(bucks).length > 0 ? (
                <div style={isMobile ? { "width": "100%" } : { "display": "flex", "flexWrap": "wrap", "width": "100%" }} className="w3-col l3 s6">
                    {Object.values(bucks).map((buck, index) => {
                        let divStyle = {};
                        if(selectedBox === index) {
                            divStyle = { "border": "2px solid black" };
                        }
                        return(
                            <div
                                key={`${buck.name}${buck.age}`}
                                onClick={() => { 
                                    if(selectedBox === index) {
                                        setSelectedBox(null);
                                    } else {
                                        setSelectedBox(index);
                                    }
                                }}
                                onDoubleClick={() => {
                                    if(onDoubleClick) {
                                        onDoubleClick(buck.name);
                                    }
                                }}
                                style={{ "display": "flex", "padding": "16px", "border": "2px solid #e8eaf6", "borderRadius": "8px", "marginTop": "16px", "alignItems": "center", "marginLeft": "8px", "marginRight": "8px", ...divStyle }}
                            >
                                <div style={{ "width": "100%", "marginRight": "16px" }}>
                                    <h3>{buck.name}</h3>
                                    <p>{buck.classification}</p>
                                    <p>{buck.age} years old</p>
                                    <p>{buck.points} points</p>
                                </div>
                                <img src={buck.images[0]} style={{ "height": "136px"}} alt={buck.name} />
                            </div>
                        );
                    })}
                </div>
            ) : <p style={{ "color": "gray" }}>No bucks created yet</p>}
        </div>
    );
};

export default BuckList;